import AvailableHeader from "./AvailableHeader";
import Card from "./Card";

function ResultsAvailable() {
  return (
    <div className="available">
      <AvailableHeader />
      <Card />
    </div>
  );
}

export default ResultsAvailable;
